import Header from "./Component/Header";
import Home from "./Component/Home";
import AboutUs from "./Component/AboutUs"
import Skills from "./Component/Skills";
import Education from "./Component/Education";
import Portfolio from "./Component/Portfolio/Portfolio";
import ContactForm from "./Component/ContactForm/ContactForm";
import Footer from "./Component/Footer";

function App() {
  return (
    <>
    <Header/>
    <Home/>
    <AboutUs/>
    <Skills/>
    <Education/>
    <Portfolio/>
    <ContactForm/>
    <Footer/>
    </>
  );
}

export default App;
